import React from 'react'
import './Contact.css'
export const Contact = () => {
    return (
        <div className="contact" id="contact">
            <div>
                <a href="https://www.google.com/maps/place/Pune,+Maharashtra/@18.5247663,73.792927,12z/data=!3m1!4b1!4m5!3m4!1s0x3bc2bf2e67461101:0x828d43bf9d9ee343!8m2!3d18.5204303!4d73.8567437" target="_blank" rel="noreferrer"><img src="https://img.icons8.com/fluency/100/000000/google-maps-new.png" alt="" /></a>
                <a href="mailto:ajinkyap331@gmail.com" target="_blank" rel="noreferrer"><img src="https://img.icons8.com/material-outlined/100/ffffff/email.png" alt="" /></a>
                <a href="https://www.linkedin.com/in/ajinkya-patil-144709208" target="_blank" rel="noreferrer"><img src="https://img.icons8.com/color/100/000000/linkedin.png" alt="" /></a>
                <a href="https://github.com/Ajinkyap331" target="_blank" rel="noreferrer"><img src="https://img.icons8.com/material-outlined/100/ffffff/github.png" alt="" /></a>
                <a href="https://www.instagram.com/ajinkya_03_03/" target="_blank" rel="noreferrer"><img src="https://img.icons8.com/fluency/100/000000/instagram-new.png" alt="" /></a>
            </div>
        </div>
    )
}
